export enum LocalStorageKey {
  "Auth" = "Auth",
}
